<template>

  <div id="basic-layout">
    <MainMenu v-model="drawer"></MainMenu>
    <HeaderBar @toggle-menu="toggleMenu"></HeaderBar>
    <v-content>
      <v-container fluid="fluid">
        <slot></slot>
      </v-container>
    </v-content>
  </div>

</template>

<script>

import HeaderBar from '@/components/HeaderBar'
import MainMenu from '@/components/MainMenu'

export default {
  name: 'BasicLayout',
  components: {
    HeaderBar,
    MainMenu
  },
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    toggleMenu () {
      this.drawer = !this.drawer
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors.scss';

#basic-layout-container {
  width: 100vw;
  height: 100vh;
}

#header-bar {
  grid-area: header;
  z-index: 2;
}

#basic-layout {
  overflow-y: auto;
}

#main-menu {
  grid-area: menu;
  z-index: 1;
}

#basic-layout-content {
  background-color: mix($background-grey, $background-light, 70%);
  grid-area: content;
  justify-self: stretch;
  align-self: stretch;
  z-index: 0;
  padding: 30px 50px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/BasicLayout.vue